export const INIT_CLIENT_ID = 'INIT_CLIENT_ID' // 初始化clientId

export const UPDATE_TOKON = 'UPDATE_TOKON' // tokon的更新
export const UPDATE_HLFTOKON = 'UPDATE_HLFTOKON' // hlftokon的更新
export const UPDATE_AUTHORIZD = 'UPDATE_AUTHORIZD' // 更新登录标识
export const INIT_USER_INFO = 'INIT_USER_INFO' // 初始化用户信息

export const INIT_CONFIG = 'INIT_CONFIG' // 初始化配置文件
export const SET_CURR_MENU = 'SET_CURR_MENU' // 设置当前菜单的配置
export const SET_CURR_PAGE = 'SET_CURR_PAGE' // 设置当前的页面

export const SET_HUBBLE_ID = 'SET_HUBBLE_ID' // 设置区分显示的ID


// WEBPACK FOOTER //
// ./src/store/mutation-types.js